// @flow
import React, { Component } from 'react';
import classnames from 'classnames';

import ReactAppContext from 'Context/ReactAppContext';
import { isFeatureFlipped } from 'Utils/feature-flipping/featureFlippingUtils';

import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';

import { Icon } from 'Components/frameworks/icon/Icon.jsx';
import { TrackClick } from 'Tracking/track-click/TrackClick.jsx';

type Props = {
  className: string,
  isActive?: boolean,
  isAuthenticated?: boolean,
  isQuickLoggedIn?: boolean,
  onClick?: (SyntheticEvent<>) => void,
  size?: number,
  title: string,
};

type State = {
  animate: boolean,
};

export class NavigationMemberAccessButton extends Component<Props, State> {
  static contextType = ReactAppContext;

  state = {
    animate: false,
  };

  componentDidMount() {
    const isAnimationEnable = !isFeatureFlipped(this.context)(
      'memberSpace.disableConnectionAnimation',
    );

    // $FlowFixMe
    this.timeoutID = setTimeout(() => {
      this.setState({ animate: true });
    }, 1500);

    if (isAnimationEnable && !this.props.isAuthenticated) {
      // $FlowFixMe
      this.intervalID = setInterval(() => {
        this.setState({ animate: true });
      }, 10000);
    }
  }

  componentDidUpdate() {
    if (this.state.animate) {
      // $FlowFixMe
      this.timeoutID = setTimeout(() => {
        this.setState({ animate: false });
      }, 2000);
    }
  }

  componentWillUnmount() {
    // $FlowFixMe
    clearTimeout(this.timeoutID);
    // $FlowFixMe
    clearInterval(this.intervalID);
  }

  render() {
    const {
      className,
      isActive,
      isAuthenticated,
      isQuickLoggedIn,
      onClick,
      size = 1.25,
      title,
    } = this.props;

    const { animate } = this.state;

    const trackingData = {
      categoryGA: 'headerMenu',
      actionGA: 'header_memberSpace',
      labelGA: 'memberSpace',
    };

    return (
      <TrackClick
        aria-expanded={isActive}
        as="button"
        className={className}
        onClick={onClick}
        title={title}
        trackingData={isActive || isAuthenticated ? null : trackingData}
        type="button"
      >
        <span className="flex relative">
          {!!title && <span className="a11y">{title}</span>}
          <Icon name={ICONS.USER} width={`${size}rem`} />
          {(isAuthenticated || isQuickLoggedIn) && (
            <span
              className={classnames(
                'absolute flex items-center justify-center leading-none rounded-half',
                {
                  'bg-emerald': isAuthenticated && !isQuickLoggedIn,
                  'bg-blue': isQuickLoggedIn,
                },
              )}
              style={{
                top: '-0.5625rem',
                right: '-0.3125rem',
                width: '0.75rem',
                height: '0.75rem',
              }}
            >
              <Icon name={ICONS.CHECK} width="0.5rem" color={COLORS.WHITE} />
            </span>
          )}
          {animate && (
            <span
              style={{
                position: 'absolute',
                top: `${size * 0.22}rem`,
                left: `${-size * 0.65}rem`,
                width: `${size * 0.8}rem`,
                height: `${size * 0.6}rem`,
                border: `solid ${size * 0.06}rem black`,
                borderRadius: '0 0 50% 80%',
                borderColor: 'transparent transparent black transparent',
                transformOrigin: 'bottom right',
                animation: 'memberAnimation 2s',
              }}
            />
          )}
        </span>
      </TrackClick>
    );
  }
}
